import React from 'react';
import unpick from '../../../utilities/unpick';

export default function NumberInput(props) {
  const { isValid, innerRef } = props;
  const p = unpick(props, ['ariaLabel', 'isValid', 'innerRef']);
  return (
    <input
      type="number"
      {...p}
      aria-label={props.ariaLabel || 'Number input'}
      aria-placeholder={props.placeholder || ''}
      aria-invalid={!isValid}
      inputMode="numeric"
      ref={innerRef}
    />
  );
}

NumberInput.propTypes = {};
